import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  DvDynamicFormElement,
  DvNumberboxElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';

@Injectable({ providedIn: 'root' })
export class CreateGeofenceDialogFormService {
  getElements = (): DvDynamicFormElement[] => [
    new DvTextboxElement({
      colspan: 12,
      key: 'Description',
      label: 'CreateGeofencePopup.Description',
      validators: [Validators.required],
    }),
    new DvNumberboxElement({
      colspan: 12,
      key: 'Radius',
      label: 'CreateGeofencePopup.Radius',
      validators: [Validators.required, Validators.min(500)],
    }),
  ];
}
